export default __webpack_public_path__ + "static/media/sortAscending_up.4a0dcd0c.svg";